import { useTranslation } from 'react-i18next'

import { Radio, Text } from '@mercai/clever'

import type { DrawerFilterCardProps } from './cards.type'

import styles from './cards.module.css'
import { useState } from 'react'
import { CatalogSearch, SupplierSearch } from '@/components'
import { CatalogProductProps, SupplierProps } from '@/types'

export const DrawerFilterCatalogProductCard = ({
  filter,
  onChangeFilter,
}: DrawerFilterCardProps) => {
  const { t } = useTranslation('screenInventoryList')

  const [selectedProduct, setSelectedProduct] = useState<
    Partial<CatalogProductProps>
  >({})

  const onSelectProduct = (newValue: Partial<CatalogProductProps>) => {
    setSelectedProduct(newValue)
    onChangeFilter({ ...filter, catalogProductUuid: newValue?.uuid || '' })
  }

  return (
    <div className={styles['content-filter']}>
      <CatalogSearch
        title={
          <Text variant="title-base" className={styles.title}>
            {t('filterCatalogProductUuid')}
          </Text>
        }
        onSelectProduct={onSelectProduct}
        selectedProduct={selectedProduct as CatalogProductProps}
      />
    </div>
  )
}

export const DrawerFilterSupplierCard = ({
  filter,
  onChangeFilter,
}: DrawerFilterCardProps) => {
  const { t } = useTranslation('screenInventoryList')

  const [selectedSupplier, setSelectedSupplier] = useState<
    Partial<SupplierProps>
  >({})

  const onSelectSupplier = (newValue: Partial<SupplierProps>) => {
    setSelectedSupplier(newValue)
    onChangeFilter({ ...filter, supplierUuid: newValue?.uuid || '' })
  }

  return (
    <div className={styles['content-filter']}>
      <SupplierSearch
        title={
          <Text variant="title-base" className={styles.title}>
            {t('filterSupplierUuid')}
          </Text>
        }
        onSelectSupplier={onSelectSupplier}
        selectedSupplier={selectedSupplier as SupplierProps}
      />
    </div>
  )
}

export const DrawerFilterRootCategoryCard = ({
  filter,
  onChangeFilter,
}: DrawerFilterCardProps) => {
  const { t } = useTranslation('screenInventoryList')

  const onChangeValue = (key: string, value: string) => {
    onChangeFilter({ ...filter, [key]: value })
  }

  return (
    <div className={styles['content-filter']}>
      <Text variant="title-base">{t('filterRootCategory')}</Text>

      <div className={styles.grid}>
        {' '}
        <Radio
          value={filter.rootCategory === ''}
          onChange={() => onChangeValue('rootCategory', '')}
        >
          {t('filterAll')}
        </Radio>
        <Radio
          value={filter.rootCategory === 'Metais'}
          onChange={() => onChangeValue('rootCategory', 'Metais')}
        >
          {t('filterRootCategoryMetales')}
        </Radio>
        <Radio
          value={filter.rootCategory === 'ResPlas'}
          onChange={() => onChangeValue('rootCategory', 'ResPlas')}
        >
          {t('filterRootCategoryResinasPlasticas')}
        </Radio>
      </div>
    </div>
  )
}

export const DrawerFilterDeliveryOptionCard = ({
  filter,
  onChangeFilter,
}: DrawerFilterCardProps) => {
  const { t } = useTranslation('screenInventoryList')

  const onChangeValue = (key: string, value: string) => {
    onChangeFilter({ ...filter, [key]: value })
  }

  return (
    <div className={styles['content-filter']}>
      <Text variant="title-base">{t('filterDeliveryOption')}</Text>

      <div className={styles.grid}>
        {' '}
        <Radio
          value={filter.deliveryOption === ''}
          onChange={() => onChangeValue('deliveryOption', '')}
        >
          {t('filterAll')}
        </Radio>
        <Radio
          value={filter.deliveryOption === 'keep_at_supplier'}
          onChange={() => onChangeValue('deliveryOption', 'keep_at_supplier')}
        >
          {t('filterDeliveryOptionKeepAtSupplier')}
        </Radio>
        <Radio
          value={filter.deliveryOption === 'deliver_to_our_warehouse'}
          onChange={() =>
            onChangeValue('deliveryOption', 'deliver_to_our_warehouse')
          }
        >
          {t('filterDeliveryOptionDeliverToOurWarehouse')}
        </Radio>
      </div>
    </div>
  )
}
